import React from "react";
import { UpdateIcon } from "@radix-ui/react-icons";
import { cn } from "@/lib/utils";

interface ProgressOverlayProps {
  isOpen: boolean;
  title: string;
  currentTask: string | null;
}

export function ProgressOverlay({
  isOpen,
  title,
  currentTask,
}: ProgressOverlayProps) {
  if (!isOpen) return null;

  return (
    <div
      className={cn(
        "fixed inset-0 z-[9999] bg-black/80 flex items-center justify-center",
        "data-[state=open]:animate-in data-[state=closed]:animate-out",
        "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
      )}
      data-state={isOpen ? "open" : "closed"}
    >
      <div className="bg-background rounded-lg p-8 shadow-lg max-w-md w-full mx-4">
        <div className="flex flex-col items-center gap-4">
          <div className="flex items-center justify-center">
            <UpdateIcon className="h-8 w-8 text-primary animate-spin" />
          </div>
          <div className="text-center">
            <h3 className="text-lg font-semibold mb-2">{title}</h3>
            {currentTask && (
              <p className="text-sm text-muted-foreground">{currentTask}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

